// YEDEK FİYATLAR (sadece ana sayfada, API cevap verene kadar gösterilir).
//
// ÖNEMLİ: Admin panelinden fiyat veya indirim oranını değiştirirseniz bu dosyayı da
// aynı değerlerle güncelleyin. Aksi halde backend uyurken ilk açılışta eski fiyat
// görünür. API cevap verir vermez gerçek fiyatlar bunun yerine geçer.
//
// prices: liste fiyatı (₺/m², indirimsiz). discountRate: yüzde.
export const FALLBACK_PRICING = {
  prices: {
    makine: 150,
    shaggy: 150,
    bambu: 200,
    viskon: 150,
    akrilik: 150,
    kilim: 150,
    el_dokuma: 250,
    yun: 200,
    isparta: 250,
    hasir: 150,
    hereke: 250,
    ladik: 250,
    step: 150,
    usak: 250,
    cin: 250,
    afgan: 250,
    bunyan: 250,
    iran: 400,
    ipek: 400,
    nepal: 250,
    deri: 250,
    patchwork: 250,
  },
  discountRate: 20,
};
